import type { FieldSchema } from '@tsagko/label-contracts'

export interface EntityGroup {
  entity: string
  fields: FieldSchema[]
}

export const DEMO_SCHEMA: EntityGroup[] = [
  {
    entity: 'Product',
    fields: [
      { key: 'productName', label: 'Product name', type: 'text' },
      { key: 'productCode', label: 'Product code', type: 'text' },
      { key: 'gtin', label: 'GTIN', type: 'text', format: 'ean-13' },
      { key: 'category', label: 'Category', type: 'enum', enumValues: ['meat', 'fish', 'cheese', 'bakery'] },
      { key: 'brand', label: 'Brand', type: 'text' },
    ],
  },
  {
    entity: 'Weight',
    fields: [
      {
        key: 'weight',
        label: 'Net weight',
        type: { kind: 'measurement', unit: 'kg', precision: 3, tolerance: 0.001 },
      },
      { key: 'unit', label: 'Unit', type: 'enum', enumValues: ['kg', 'g', 'lb'] },
    ],
  },
  {
    entity: 'Pricing',
    fields: [
      { key: 'price', label: 'Price', type: { kind: 'currency', iso4217: 'EUR' } },
      { key: 'discountPct', label: 'Discount %', type: 'number' },
    ],
  },
  {
    entity: 'Temporal',
    fields: [
      { key: 'manufacturedAt', label: 'Manufactured at', type: 'date' },
      { key: 'expiresAt', label: 'Expires at', type: 'date' },
      { key: 'bestBefore', label: 'Best before', type: 'date' },
    ],
  },
  {
    entity: 'Regulatory',
    fields: [
      { key: 'countryOfOrigin', label: 'Country of origin', type: 'text' },
      { key: 'allergens', label: 'Allergens', type: 'text' },
      { key: 'producerLogo', label: 'Producer logo', type: 'image' },
    ],
  },
]

export function flattenSchema(groups: EntityGroup[]): Array<{ entity: string; field: FieldSchema }> {
  return groups.flatMap(g => g.fields.map(f => ({ entity: g.entity, field: f })))
}
